import React from 'react';
import { ButtonGroup, Dropdown } from 'react-bootstrap';

import { DownloadLink } from '../../../../General/DownloadLink';

interface Props {
    pdfUrl?: string;
    externalPdfUrl?: string;
    disableExternal?: boolean;
}

const ExportPDF: React.FC<Props> = ({ pdfUrl, externalPdfUrl, disableExternal }: Props) => {
    if (pdfUrl === undefined && externalPdfUrl === undefined) {
        return null;
    }

    return (
        <Dropdown as={ButtonGroup}>
            <DownloadLink url={pdfUrl} className="btn btn-primary">
                Open
            </DownloadLink>
            {disableExternal !== true && (
                <>
                    <Dropdown.Toggle split variant="primary" />
                    <Dropdown.Menu>
                        <Dropdown.Item className="export-pdf-link" as={DownloadLink} url={pdfUrl}>
                            Renteblad
                        </Dropdown.Item>
                        {externalPdfUrl && (
                            <Dropdown.Item className="export-pdf-link" as={DownloadLink} url={externalPdfUrl}>
                                Renteblad geldverstrekker
                            </Dropdown.Item>
                        )}
                    </Dropdown.Menu>
                </>
            )}
        </Dropdown>
    );
};

export default ExportPDF;
